import api from './apiService';
import dayjs from "dayjs";

export const getFilter = async (params) => {
    try {
        if (params.creationDate) {
            // Formatar as datas para o formato americano
            params.creationDate = params.creationDate.map((date) =>
                dayjs(date).format("YYYY-MM-DD")
            );
        }
        if (params.startDate) {
            // Formatar as datas para o formato americano
            params.startDate = params.startDate.map((date) =>
                dayjs(date).format("YYYY-MM-DD")
            );
        }
        if (params.dueDate) {
            // Formatar as datas para o formato americano
            params.dueDate = params.dueDate.map((date) =>
                dayjs(date).format("YYYY-MM-DD")
            );
        }
        const queryString = buildQueryString(params);
        const response = await api.get(`/task?${queryString}`);

        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getById = async (id) => {
    try {
        const response = await api.get(`/task/${id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getTasksInProgress = async () => {
    try {
        const response = await api.get('/task/in-progress');

        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const storeTasks = async (data) => {    
    try {
        const response = await api.post('/task', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateTasks = async (data) => {
    try {
        const response = await api.put('/task', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const workTime = async (id, action) => {
    try {
        const response = await api.get(`/task/work/${id}/${action}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const workLog = async(idTask) => {
    try {
        const response = await api.get(`/task/work/${idTask}/log`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getCategories = async () => {
    try {
        const response = await api.get('/task/categories');
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const storeCategory = async (data) => {
    try {
        const response = await api.post('/task/categories', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const updateCategory = async (data) => {
    try {
        const response = await api.put('/task/categories', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const deleteCategory = async (id) => {
    try {
        const response = await api.delete(`/task/categories/${id}`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

function buildQueryString(params) {
    return Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
}

export const storeComments = async (data) => {    
    try {
        const response = await api.post('/task/comments', data);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}

export const getComment = async(idTask) => {
    try {
        const response = await api.get(`/task/${idTask}/comments`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}